import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Response } from '@angular/http';
import { Subscription } from 'rxjs/Subscription';
import { JhiAlertService, JhiEventManager } from 'ng-jhipster';

import { QueueService, RegistrationService, Principal } from '../../services';
import { Account, Queue, Registration } from '../../models';
import { AlertUtils, ParamUtils } from '../../shared';

@Component({
    selector: 'qms-queues-handling',
    templateUrl: './queues-handling.component.html',
    styleUrls: ['queues-handling.component.css']
})
export class QueuesHandlingComponent implements OnInit, OnDestroy {
    public queue: Queue;
    public hasAccess: boolean;
    public processingRegistration: Registration;

    private queueId: number;
    private currentAccount: Account;
    private subscription: Subscription;

    constructor(private eventManager: JhiEventManager,
                private alertService: JhiAlertService,
                private route: ActivatedRoute,
                private router: Router,
                private queueService: QueueService,
                private registrationService: RegistrationService,
                private principal: Principal) {
    }

    ngOnInit() {
        this.hasAccess = false;
        this.subscription = this.route.params.subscribe((params) => {
            ParamUtils.parseNumber(params['id'], (queueId: number) => {
                this.queueId = queueId;
                this.load(this.queueId);
                this.processingRegistration = null;
                this.loadCurrent();
            }, () => {
                AlertUtils.notifyNotFound(this.eventManager, this.alertService);
            });
        });
    }

    ngOnDestroy() {
        // TODO: Popup: 'Process registration?'
        // this.process();
    }

    private load(id: number) {
        this.principal.identity(true).then((account: Account) => {
            this.currentAccount = account;
            this.queueService.find(id).subscribe((queue: Queue) => {
                this.hasAccess = this.principal.hasAccessToFaculty(queue.facultyId);
                this.queue = queue;
                if (queue.category) {
                    this.redirectToFirstChild();
                }
            });
        });
    }

    private loadCurrent() {
        if (this.processingRegistration == null) {
            this.registrationService.takeCurrent(this.queueId).subscribe((registrations: Registration[]) => {
                if (registrations != null && registrations.length > 0) {
                    this.processingRegistration = registrations[0];
                }
            });
        }
    }

    public processAndTakeNext() {
        if (this.processingRegistration != null) {
            this.registrationService.process(this.processingRegistration.id).subscribe((response: Response) => {
                this.takeNext();
            });
        } else {
            this.takeNext();
        }
    }

    public takeNext() {
        this.registrationService.takeNext(this.queueId).subscribe((registration: Registration) => {
            this.processingRegistration = registration;
            if (this.processingRegistration == null) {
                AlertUtils.notifyInfo(this.eventManager, this.alertService,
                    'queuesHandling.alerts.noPendingRegistrations', { param: this.queue.name });
            }
        });
    }

    public process() {
        if (this.processingRegistration != null) {
            const label: string = this.processingRegistration.labelToDisplay;
            this.registrationService.process(this.processingRegistration.id).subscribe((response: Response) => {
                AlertUtils.notifySuccess(this.eventManager, this.alertService,
                    'queuesHandling.alerts.processed', { 'label': label });
            });
            this.processingRegistration = null;
        }
    }

    public markExpired() {
        const label: string = this.processingRegistration.labelToDisplay;
        this.registrationService.markExpired(this.processingRegistration.id).subscribe((response: Response) => {
            AlertUtils.notifySuccess(this.eventManager, this.alertService,
                'queuesHandling.alerts.markedExpired', { 'label': label });
        });
        this.processingRegistration = null;
    }

    public startProcessing() {
        this.queueService.startProcessing(this.queueId).subscribe((response: Response) => {
            this.load(this.queueId);
        });
    }

    public stopProcessing() {
        this.queueService.stopProcessing(this.queueId).subscribe((response: Response) => {
            this.load(this.queueId);
        });
    }

    public startBreak() {
        this.queueService.startBreak(this.queueId, 1).subscribe((response: Response) => {
            this.load(this.queueId);
        });
    }

    public startRegistration() {
        this.queueService.startRegistration(this.queueId).subscribe((response: Response) => {
            this.load(this.queueId);
        });
    }

    public stopRegistration() {
        this.queueService.stopRegistration(this.queueId).subscribe((response: Response) => {
            this.load(this.queueId);
        });
    }

    private redirectToFirstChild() {
        this.queueService.findChildren(this.queue.id).subscribe((children: Queue[]) => {
            if (children[0] != null) {
                this.router.navigate(['/queue-handling', children[0].id]);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/queues-handling/queues-handling.component.ts